import { EventTypes } from 'types/events'

export function getTowFromForm(formValues: any) {
  return {
    eventType: EventTypes.TOW,
    attributes: { serviceLocations: formValues.serviceLocations },
  }
}
